module.exports = __webpack_public_path__ + "3c5ce87775d9eff7b4d3a4fe46ae0fd5.svg";